import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { ExecutionOfTrafficOrganizationProjectsForm } from './forms/execution-of-traffic-organization-projects.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../../components/content/content.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ServiceListItem } from '../../../../services/service.common.model';
import { selectLoading, selectServiceByUrl } from '../../../../store/selectors/app.selectors';
import {
  ExposedMapControlComponent
} from '../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ValidationErrorsComponent } from '../../../../common/validation-errors/validation-errors.component';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import { SmartGemCommonService } from '../../../../services/smart-gem.common.service';
import { AlertComponent } from '../../../../common/alert/alert.component';
import {
  ExecutionOfTrafficOrganizationProjectsMapComponent
} from '../../application/common/components/execution-of-traffic-organization-projects-map/execution-of-traffic-organization-projects-map.component';
import { Subscription } from 'rxjs';
import { selectApplication } from '../../../../store/selectors/application.selectors';
import { loadApplication, setApplication } from '../../../../store/actions/application.actions';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-execution-of-traffic-organization-projects',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    ExposedMapControlComponent,
    ValidationErrorsComponent,
    SpinnerComponent,
    AlertComponent,
    ExecutionOfTrafficOrganizationProjectsMapComponent
  ],
  providers: [
    ExecutionOfTrafficOrganizationProjectsForm
  ],
  templateUrl: './execution-of-traffic-organization-projects.component.html'
})
export class ExecutionOfTrafficOrganizationProjectsComponent implements OnInit, OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public appId: string | undefined = this.route.snapshot.params['appId'];

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public pending = false;

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl('wykonanie-projektow-organizacji-ruchu'));

  public form: ExecutionOfTrafficOrganizationProjectsForm = inject(ExecutionOfTrafficOrganizationProjectsForm);

  private smartGemService: SmartGemCommonService = inject(SmartGemCommonService);

  public application = this.store$.selectSignal(selectApplication);

  public contentUrl: string | null = null;

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onSubmit(): void {
    if (this.form.valid) {
      this.pending = true;
      if (!this.application()?.description) {
        this.smartGemService.getTrafficOrganizationDesignURL({
          geometry: this.form.geometry.value,
          service: this.serviceType()?.uuid || '',
          applicationSubject: this.form.applicationSubject.value,
          projectType: this.form.projectType.value
        }).subscribe({
          next: (v) => {
            this.router.navigate(['../../wnioski-robocze/wykonanie-projektow-organizacji-ruchu', v.uuid]).then(() => {
              this.contentUrl = v.description || null;
            });
            this.pending = false;
          },
          error: () => {
            this.pending = false;
          }
        });
      } else {
        this.smartGemService.submitTrafficOrganizationDesign({
          geometry: this.form.geometry.value,
          service: this.serviceType()?.uuid || '',
          applicationSubject: this.form.applicationSubject.value,
          projectType: this.form.projectType.value
        }, this.appId || '').subscribe({
          next: (v) => {
            //  this.router.navigate(['/wnioski-zatwierdzone' + this.application()?.service?.url, this.appId], { state: { message: 'applicationApproved' } });
            this.router.navigate(['/wnioski-zatwierdzone']);
            this.pending = false;
          },
          error: () => {
            this.router.navigate(['/wnioski-zatwierdzone'], { state: { message: 'projectApproved' } });
            this.pending = false;
          }
        });
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit() {
    if (this.appId) {
      this.store$.dispatch(loadApplication({ id: this.appId }));
    }
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({ application: null }));
    this.fetchApplication.unsubscribe();
  }

}
